// import { InputOptionType } from "components/Input/InputType"


export type StatusType= 0|1|2|3


export  const  StatusOptions=[
    {label:"waiting",value:"0",icon:"AlertCircleIcon"},
    {label:"active",value:"1",icon:"CheckCircleIcon"},
    {label:"passive",value:"2",icon:"XCircleIcon"},
    {label:"deleted",value:"3",icon:"XCircleIcon"},
] as any[]

export const StatusMap={
    0:"waiting",
    1:"active",
    2:"passive",
    3:"deleted"
}


export const StatusFlags= {
    WAITING : 0,
    ACTIVE : 1,
    PASSIVE : 2,
    DELETED : 3,
}
